import PropTypes from 'prop-types';
import React from 'react';

import style from './style.module.scss';

const propTypes = {
  text: PropTypes.string,
};

const TableEmptyRow = ({ text }) => {
  return (
    <tr className={style.emptyRow}>
      <td className={style.emptyRowBlock} colSpan={30}>
        <span className={style.emptyRowText}>{text}</span>
      </td>
    </tr>
  );
};

TableEmptyRow.propTypes = propTypes;

export default TableEmptyRow;
